<template>
	<div class="absolute">
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="medium2"
            @close="close"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Output') }}</h5>
            </template>
            <template slot="body">
                <h5 class="mb-2 pl-1 mt-4 text-left">{{ $t('SELECT OUTPUT(S)') }}</h5>
                <p class="mb-3 pl-1 text-left">{{ $t('Please select one or more') }} <span @click="goToDisplay" class="text-primary pointer">{{ $t('output') }} </span>{{ $t('for this rundown') }}</p>
				<div class="header-output-display">
					<ul class="list-nonstyle mb-1">
						<li class="display-output-list-header pl-4">
							<div class="d-flex display-outpust-list-wrapper">
								<div class="mr-9">
									{{$t('Name')}}
								</div>
								<div class="mr-5 ml-3">
									{{$t('Type/Output layer')}}
								</div>
								<div class="ml-5 pl-2">
									{{$t('Rundown')}}
								</div>
							</div>
						</li>
					</ul>
				</div>
                <div class="display-output-list mr-2 ml-1" id="styleScroll">
					<div class="p-5 text-center" v-if="isFetching || isFetchingRundown">
						<div class="is-loading large">
						</div>
					</div>
					<div v-if="items.length > 0 && rundownId && !isFetchingRundown">
						<div v-for="(item, index) in items" :key="item.id">
							<ul class="list-nonstyle mb-1">
								<li class="display-output-list-item pl-4">
									<!-- display output name -->
									<div class="d-flex display-outpust-list-wrapper">
										<div class="display-modal-name pt-2"
										:class="{
											// check if and assigned
											'text-white': arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id === null && itemsDisplay[index].rundown_id !== rundownId,
											'disabled': arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id === null && itemsDisplay[index].rundown_id !== rundownId,
											// check if unassigned
											'text-grey': arrayDisplay[index].rundown_id !== rundownId,
											// check if saving and assigned
											'text-display-output': arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId,
										}">
											<template v-if="item.name.length > 24">
												<!-- check if saving and assigned -->
												<span v-if="arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId" @click="viewDisplay(item)" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
												<!-- check if assigned -->
												<span v-if="arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id !== rundownId" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
												<!-- check if unassigned -->
												<span v-if="arrayDisplay[index].rundown_id !== rundownId" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
											</template>
											<template v-if="item.name.length < 24">
												<!-- check if saving and assigned -->
												<span v-if="arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId" @click="viewDisplay(item)">{{ trimDisplayName(item.name) }}</span>
												<!-- check if assigned -->
												<span v-if="arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index].rundown_id !== rundownId">{{ trimDisplayName(item.name) }}</span>
												<!-- check if unassigned -->
												<span v-if="arrayDisplay[index].rundown_id !== rundownId">{{ trimDisplayName(item.name) }}</span>
											</template>
										</div>
										<!-- layer index on display output -->
										<div class="text-center w-140">
											<div class="d-flex pt-2">
												<div class="ml-3 mr-2"
													:class="{
														'dot-black': item.background_color === '#000000',
														'dot-white': item.background_color === 'background:none',
														'dot-green': item.background_color === '#00FF00',
													}"
													>
												</div>
												<div v-if="item.layer_index.length <= 30" class="mr-a">
													{{ printLayerIndex(item) }}
												</div>
												<div v-tooltip.bottom-end="printLayerIndex(item)" v-if="item.layer_index.length > 30"  class="mr-a truncate-display-modal-index">
													{{ printLayerIndex(item) }}
												</div>
											</div>
										</div>
										<!-- rundown name on display output -->
										<div class="d-flex pt-2 pr-3 text-center">
											<div class="truncate-display-modal-rundown-name">
												{{item && item.rundown && item.rundown.name ? item.rundown.name : ''}}
											</div>
										</div>
										<div class="button-assign pt-1 ml-4">
											<button v-if="arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId" class="btn btn-default btn-assign" @click="selectedDisplay(item)">{{$t('Unpublish')}}</button>
											<button v-if="arrayDisplay[index].rundown_id !== rundownId" class="btn btn-primary btn-assign" @click="selectedDisplay(item)">{{$t('Publish')}}</button>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="text-center mt-20" v-if="items.length === 0 && !isFetching">
						{{$t('No Display Available')}}
					</div>
                </div>
				<div class="d-flex justify-content-between" v-if="items.length > 0">
					<button class="btn btn-primary mt-4" @click="select()">{{$t('Save')}}</button>
					<button class="btn btn-secondary mt-4" @click="close()">{{$t('Cancel')}}</button>
				</div>
            </template>
		</modal>
	</div>
</template>

<script>

import Modal from '@/components/Modal.vue';
import displaysApi from '@/api/displays';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import rundownsApi from '@/api/rundowns';

export default {
	name: 'ModalOutputDisplay',
	components: {
		Modal,
	},
	props: {
	},
	mounted() {
	},
	data: () => ({
		items: [],
		arrayDisplay: [],
		isSaving: false,
		rundownId: null,
		displayByRundown: [],
		displayIdByRundown: [],
		display: {
			id: null,
			rundown_id: null,
		},
		itemsDisplay: [],
		isFetching: false,
		isFetchingRundown: false,
	}),
	methods: {
		close() {
			this.arrayDisplay = [];
			this.itemsDisplay = [];
			this.$emit('close');
		},
		printLayerIndex(item) {
			const layerIndex = item && item.layer_index ? JSON.parse(item.layer_index) : null;
			if (Array.isArray(layerIndex) && layerIndex.length && !layerIndex.includes('0')) {
				return JSON.parse(item.layer_index).toString();
			}
			return 'All';
		},
		fetch() {
			this.isFetching = true;
			this.items = [];
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
			};
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				if (this.items.length > 0) {
					for (let index = 0; index < this.items.length; index++) {
						const display = {};
						display.id = this.items[index].id;
						display.rundown_id = this.items[index].rundown_id || null;
						this.arrayDisplay.push(duplicateVar(display));
						this.itemsDisplay.push(duplicateVar(display));
					}
				}
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: '',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		selectedDisplay(display) {
			const index = this.arrayDisplay.findIndex(({ id }) => id === display.id);
			if (index > -1) {
				const currentDisplay = this.arrayDisplay[index];
				if (currentDisplay.rundown_id === null) { // if rundown_id in array display null or empty
					currentDisplay.rundown_id = this.rundownId; // rundown_id in array display replaced by current rundowwn id
				} else if (currentDisplay.rundown_id !== this.rundownId) { // if rundown_id in array display not same as current rundown id
					currentDisplay.rundown_id = this.rundownId; // rundown_id in array display replaced by current rundowwn id
				} else if (currentDisplay.rundown_id === this.rundownId) { // if rundown_id in array display is same as current rundown id
					if (display.rundown_id !== this.rundownId) { // and if rundown_id in display data not same as current rundown id
						currentDisplay.rundown_id = display.rundown_id; // rundown id in array display replaced by rundown_id in display data
					} else { // and if rundown_id in display data is same as current rundown id
						currentDisplay.rundown_id = null; // rundown id in array display replaced by null
					}
				}
			}
		},
		select() {
			this.isSaving = true;
			const callback = (response) => {
				const message = response.message;
				const data = response.data;
				this.arrayDisplay = [];
				this.itemsDisplay = [];
				Object.assign(this.items, data);
				// communication between any components
				this.$root.$emit('updateDisplayOutput');
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Displays',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Device Monitor',
					text: message,
				});
				this.arrayDisplay = [];
				this.itemsDisplay = [];
				this.isSaving = false;
			};
			displaysApi.removeRundown(this.arrayDisplay, callback, errorCallback);
		},
		getRundownData() {
			this.isFetchingRundown = true;
			this.rundownId = null;
			const callback = (response) => {
				const rundown = response.data;
				this.rundownId = rundown.id;
				this.arrayDisplay = [];
				if (this.items.length > 0) {
					for (let index = 0; index < this.items.length; index++) {
						const display = {};
						display.id = this.items[index].id;
						display.rundown_id = this.items[index].rundown_id;
						this.arrayDisplay.push(display);
					}
				}
				this.isFetchingRundown = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isFetchingRundown = false;
			};
			rundownsApi.getBySlug(atob(this.activeRouteSlug), callback, errorCallback);
		},
		goToDisplay() {
			this.$emit('close');
			this.$router.push('/displays').catch(() => {});
		},
		viewDisplay(item) {
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `/displays/live/${item.slug}/${item.id}?rundown_id=${rundownId}`;
			const routeData = this.$router.resolve({ path: url });
			window.open(routeData.href, '_blank');
		},
		trimDisplayName(str) {
			let result = '';
			if (str.length > 24) {
				result = `${str.substring(0, 24)}...`;
			} else {
				result = str;
			}
			return result;
		},
	},
	computed: {
		activeRouteSlug() {
			return this.$route.params.slug;
		},
	},
	watch: {
	},
	created() {
		this.fetch();
		this.getRundownData();
	},
};
</script>
